export default __webpack_public_path__ + "static/media/dragon.e34d9ff5.png";